import { Pencil, TrashBin } from '@gravity-ui/icons'
import { Button, Table, Tooltip } from '@heroui/react'
import { useTranslation } from 'react-i18next'

import { UserAvatar } from '@/components/common/UserAvatar'
import type { Driver } from '@/types/driver.types'
import type { Vehicle } from '@/types/vehicle.types'

interface DriverTableRowProps {
  driver: Driver;
  vehicle?: Vehicle;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

export function DriverTableRow({ driver: d, vehicle, onEdit, onDelete }: DriverTableRowProps) {
  const { t } = useTranslation()


  return (
    <Table.Row key={d.id} className="cursor-pointer">
      <Table.Cell onClick={() => onEdit(d.id)}>
        <div className="flex items-center gap-3">
          <UserAvatar name={d.fullName} size="sm" />
          <span className="font-black truncate">{d.fullName}</span>
        </div>
      </Table.Cell>
      <Table.Cell onClick={() => onEdit(d.id)}>{d.phone}</Table.Cell>
      <Table.Cell onClick={() => onEdit(d.id)}>
        <div className="flex flex-col">
          <span className="font-medium text-zinc-900 dark:text-zinc-100">{vehicle?.plate || '—'}</span>
          {vehicle && (
            <span className="text-xs font-medium text-zinc-400 dark:text-zinc-500 truncate">
              {vehicle.brand}
            </span>
          )}
        </div>
      </Table.Cell>

      <Table.Cell onClick={() => onEdit(d.id)}>
        <div className="flex justify-end gap-2">
          <Tooltip delay={0}>
            <Button
              isIconOnly size="sm" variant="tertiary" onClick={e => {
                e.stopPropagation()
                onEdit(d.id)
              }}
            >
              <Pencil className="size-4" />
            </Button>
            <Tooltip.Content>
              <p>{t('common.edit')}</p>
            </Tooltip.Content>
          </Tooltip>

          <Tooltip delay={0}>
            <Button
              isIconOnly size="sm" variant="danger-soft" onClick={e => {
                e.stopPropagation()
                onDelete(d.id)
              }}
            >
              <TrashBin className="size-4" />
            </Button>
            <Tooltip.Content>
              <p>{t('common.delete')}</p>
            </Tooltip.Content>
          </Tooltip>
        </div>
      </Table.Cell>
    </Table.Row>
  )
}
